import { render } from "./messagesGeneral.vue?vue&type=template&id=18f263c7"
import script from "./messagesGeneral.vue?vue&type=script&lang=js"
export * from "./messagesGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__